import * as React from 'react';
import { Box } from 'localmed-core';

export default function ProfilePanelList(props) {
  return <Box flex={['1']} {...props} />;
}
